/* src/components/project-risks/project-risks.component.scss */
:host {
  display: block;
}
/*# sourceMappingURL=project-risks.component-6L7CH5L4.css.map */
